<template>
    <el-dialog
        :title="'编辑表单项'"
        :visible.sync="levelDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="hanldClose"
        width="500px"
        center
    >
        <el-form
            :model="levelForm"
            :rules="rules"
            ref="levelForm"
            label-width="100px"
        >
            <el-form-item label="级别名称" prop="name">
                <el-input type="text" v-model="levelForm.name"></el-input>
            </el-form-item>
            <el-form-item label="会费设置" prop="price">
                <el-input type="text" v-model="levelForm.price" :precision="2">
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('levelForm')"
                >取消
                </el-button
                >
                <el-button
                    class="padding-lr-xl"
                    type="primary"
                    @click="submitForm('levelForm')"
                >提交
                </el-button
                >
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>


import {setRank} from "@/api/branch";
import rules from "@/utils/rules";

export default {
    name: "levelDialog",
    props: {
        levelDialog: {
            type: Boolean,
            default: false
        },
        setIndex: {
            type: Number,
            default() {
                return -1;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {
        return {
            levelForm: {
                name: '',
                price: '',

            },
            rules: {
                name: [
                    {required: true, message: '请输入级别名称', trigger: 'blur'},
                ],
                price: [
                    {required: true, message: '请选择级别会费', trigger: 'blur'},
                    rules.money
                ],

            },
        }
    },
    created() {
    },
    methods: {
        hanldClose() {
            this.$emit('cancelDialog', false)
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await setRank(this.levelForm.name, this.levelForm.price, this.setItem ? this.setItem.id : '')
            if (_state.status === 200) {
                this.$message.success('编辑成功')
                this.$refs[formName].resetFields();
                this.$emit('cancelDialog', true)
            }
        }
    },
    watch: {
        setItem() {
            this.levelForm = {
                name: this.setItem ? this.setItem.name : '',
                price: this.setItem ? this.setItem.price : '',
            };
        }
    }
}
</script>

<style scoped lang="scss">
</style>